import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.61106 1.98213C7.96093 1.64561 7.16066 1.899 6.8236 2.54964L5.60067 4.99006L5.60036 4.99068C5.55287 5.08413 5.46249 5.14861 5.35873 5.16317L2.63277 5.55573C2.341 5.59509 2.07036 5.73166 1.86567 5.94389C1.36467 6.46431 1.3808 7.29157 1.89976 7.79217L1.90066 7.79304L3.87466 9.68771L3.87554 9.68857C3.94851 9.75824 3.98155 9.85917 3.96435 9.95764L3.49766 12.6331L3.49672 12.6386C3.45036 12.9232 3.49917 13.2132 3.63264 13.4662L3.63328 13.4675C3.97424 14.1096 4.77058 14.3548 5.41358 14.0152L7.8484 12.7532C7.9444 12.7037 8.05813 12.7036 8.15406 12.7532L10.5855 14.0135L10.5877 14.0146C10.8402 14.1478 11.1291 14.1957 11.4115 14.1508L11.4125 14.1506C12.1312 14.0348 12.6212 13.3586 12.5052 12.6388L12.0375 9.95771L12.0373 9.95664C12.0198 9.85804 12.0527 9.75791 12.1256 9.68851L14.1 7.79157C14.3129 7.58624 14.4497 7.31451 14.4885 7.02217L14.4887 7.02137C14.5823 6.30777 14.0817 5.65077 13.3667 5.55502L10.6428 5.16275L10.6411 5.1625C10.537 5.14789 10.4471 5.08325 10.4004 4.9906L9.182 2.55589L9.17893 2.54983C9.05293 2.30641 8.85493 2.10792 8.61106 1.98213Z",
			fill: "currentColor"
		})
	})
});
export default SvgStarFill;
